import Appsignal from "@appsignal/javascript";

// myUMBC environment and version
function getMetaContent(name) {
    const meta = document.querySelector(`meta[name="${name}"]`)
    return meta ? meta.getAttribute('content') : null
}

const myumbcEnvironment = getMetaContent('myumbc:environment') || 'production'
const myumbcBuild = getMetaContent('myumbc:build')

const appsignalKeys = {
    production: "e0fb77e0-f235-42c7-bc66-9a98b68ed0aa",
    staging: "e13bc010-0bff-416f-9496-5ad34311a119",
    development: "27a36055-bb03-4b5a-8068-7046f4a01efe"
};
const appsignalKey = appsignalKeys[myumbcEnvironment] || appsignalKeys.production;

export const appsignal = new Appsignal({
  key: appsignalKey,
  revision: myumbcBuild
});
